import { getCloneId } from 'utils';
import { colorizeSprite } from '../utils/PixiUtils';
import { FrameData, SolidFrameData } from './FlyerData';
import { Frame } from './Frame';
import { FrameType } from './FrameType';

const PIXI = (window as any).PIXI;

export class SolidFrame extends Frame {
  type = FrameType.SolidColor;
  isEditable = true;

  private _color = '';
  get color(): string {
    return this._color;
  }
  set color(value: string) {
    this._color = value;
    if (this.sprite) {
      colorizeSprite(this.sprite, value);
      // this.updateTexture();
    }
    this.emit('update');
    this.generateThumbnail();
    this.emit('edited');
  }

  async load() {
    if (this.isLoaded) {
      return;
    }
    this.isLoaded = true;
    this.generateThumbnail();
    this.emit('load');
  }

  generateThumbnail(): void {
    if (this.thumbnailURL) {
      URL.revokeObjectURL(this.thumbnailURL);
    }
    const THUMBNAIL_SIZE: number = 120;
    const canvas = document.createElement('canvas');
    canvas.width = THUMBNAIL_SIZE;
    canvas.height = THUMBNAIL_SIZE;
    var ctx: CanvasRenderingContext2D = canvas.getContext('2d')!;

    ctx.fillStyle = this.color;
    ctx.fillRect(0, 0, THUMBNAIL_SIZE, THUMBNAIL_SIZE);
    this.thumbnailURL = canvas.toDataURL('image/png');
  }

  populateWithData(data: FrameData) {
    const solidData = data as SolidFrameData;
    this.color = solidData.color;
    this.sprite.texture = PIXI.Texture.WHITE;
    colorizeSprite(this.sprite, this.color);
    this.boundingBox = new PIXI.Rectangle(
      0,
      0,
      this.stageWidth,
      this.stageHeight
    );
  }

  asData(forDatabase: boolean): FrameData {
    const { color } = this;
    const result: SolidFrameData = {
      ...super.asData(forDatabase),
      color
    };
    return result;
  }

  clone(copyIndex: number): Frame {
    const clone = new SolidFrame(this.stageWidth, this.stageHeight);
    clone.id = getCloneId(this.id, copyIndex);
    clone.populateWithData(this.asData(false));
    return clone;
  }
}



// WEBPACK FOOTER //
// ./src/data/SolidFrame.ts